<template>
	<v-dialog v-model="visible_local" :max-width="maxWidth">
		<v-alert class="mb-0 rounded-b-0" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<div class="share-dialog px-5">
			<div class="share-list">
				<div class="share-title">Shared with</div>
				<div
					:key="user.id" 
					v-for="user in acl"
					class="mb-1"
				>
					<v-chip 
						v-if="user.adbid || user.name !== 'System administrator'"
						color="grey-lighten-3"
						close pill
						close-icon="mdi-minus"
						@click="onShare(user.usid, false)"
						@click:close="onShare(user.usid, false)"
					>
						<v-user-avatar
							v-if="user.usid > 0"
							color="#192a3e"
							:code="user.name"
							:image="user.adbid ? `/api/addressbook/${user.adbid}/image.png`: ''"
							left
						/>
						<span>{{ user.name }}</span>
					</v-chip>
				</div>
				<div class="mt-8 share-title">Share...</div>
				<ProgressLinear  v-if="loading"/>
				<div
					:key="user.id" 
					v-for="user in unselected_users"
					class="mb-1"
				>
					<v-chip 
						v-if="user.adbid || user.name !== 'System administrator'"
						color="grey-lighten-3"
						close pill
						close-icon="mdi-plus"
						@click="onShare(user.id, true)"
						@click:close="onShare(user.id, true)"
					>
						<v-user-avatar
							v-if="user.id > 0"
							color="#192a3e"
							:code="user.name"
							:image="user.adbid ? `/api/addressbook/${user.adbid}/image.png`: ''"
							left
						/>
						<span>{{ user.name }}</span>
					</v-chip>
				</div>

			</div>
			<div class="ml-5 share-link">
				<div class="share-title">Link</div>
				<v-textarea
					id="copylink"
					:value="link_url"
					background-color="#FFFFFF"
					:color="color"
					outlined
					dense
					hide-details
					readonly
					auto-grow
					rows="3"
				></v-textarea>
				<v-btn depressed :color="'#00AAFD'" class="mt-2 white--text text-capitalize" @click="onCopyLink()">Copy Link</v-btn>
			</div>
		</div>
	</v-dialog>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";

export default {
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: Number,
			default: 500
		},
		tasklistId: {
			type: Number,
			default:0
		},
		tasklistAcl: {
			type: Array,
			default: () => []
		},
		tasklistOwner: {
			type: Object,
			default: () => {}
		},
		color: {
			type: String,
			default: ''
		}
	},
	components: {
		ProgressLinear
	},
	data() {
		return {
			error_msg: '',
			loading: false,
			visible_local: this.visible,
			users: [],
			acl: [],
		}
	},
	created() {
		this.load_users();
	},
	watch: {
		tasklistAcl() {
			this.acl = this.tasklistAcl;
		},
		visible_local() {
			if (!this.visible_local) {
				this.$emit('close');
			}
		}
	},
	computed: {
		unselected_users() {
			let unselected = [];

			const able_to_select = this.users.filter(user => { return user.id !== this.tasklistOwner.id });

			if (this.acl.lenght !== 0) {
				const acl_usids = this.acl.map(t => { return t.usid });
				unselected = able_to_select.filter(element => { return !acl_usids.includes(element.id) });
				
			} else {
				unselected = able_to_select;
			}

			return unselected;
		},
		link_url() {
			return `${window.location.origin}/tasks/tasklist/${this.tasklistId}`;
		}
	},
	methods: {
		load_users() {
			this.loading = true;
			const url = '/api/users';

			axios
				.get(url, {}, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason }= val.data;

					if (status == "OK") {
						const data_tmp = JSON.parse(JSON.stringify(data));
						data_tmp.forEach(e => {
							if (e.name.includes(',')) {
								const name_arr = e.name.split(',');
								if (name_arr[1].includes('(')) {

									const name_tmp = name_arr[1];
									const index = name_tmp.indexOf('(');
									e.name = `${name_tmp.substring(0, index-1)} ${name_arr[0]} ${name_tmp.substring(index, name_tmp.length)}`;
								} else {
									e.name = `${name_arr[1]} ${name_arr[0]}`;
								}							
							}
						});
						this.users = data_tmp;
						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		onShare(usid, enabled) {
			this.error_msg = '';
			const url = `/api/worklists/${this.tasklistId}/shared/${usid}`;
			const param = { enabled: enabled };

			axios
				.put(url, param, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const {status, data, reason} = val.data;

					if (status == "OK") {
						this.acl = data ? data: [];
						// this.$emit('changed_share', this.acl);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onCopyLink() {
			navigator.clipboard.writeText(this.link_url).then(() => {
				/* clipboard successfully set */
				this.$emit('copy-link', true);
				
			}, () => {
				/* clipboard write failed */
				this.$emit('copy-link', false);
				
			});
		}
	}
}
</script>
<style lang="scss" scoped>
.share-dialog {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	background: #FFFFFF;
}
.share-list {
	display: flex;
	flex-flow: column nowrap;
}
.share-title {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 32px;
	color: #000000;
}
.share-link {
	width: 100%;
}
</style>
